module.exports = __webpack_public_path__ + "img/scopeGuide.83270042.png";